import { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { OBJECT_TYPE } from "common/constants";
import { GetWorkflowQuery } from "../../generated/graphql";
import { AuthContext } from "../Authorization/AuthContext";
import { Button } from "../Common/Buttons/Button";
import { getOnCallToActionClick } from "./workflowUtils";

type WorkflowStep = Omit<
  NonNullable<GetWorkflowQuery["workflow"]>["workflowSteps"][number],
  "status"
>;

const getCtaText = (workflowStep: WorkflowStep): string => {
  return workflowStep.submission ? "View" : "Create";
};

export const WorkflowStepCTA = ({
  workflowStep,
  objectId,
  objectType,
  isManualMode,
  canCreate,
  canView,
}: {
  workflowStep: WorkflowStep;
  objectId?: string;
  objectType?: OBJECT_TYPE;
  isManualMode: boolean;
  canCreate: boolean;
  canView: boolean;
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { isPublic } = useContext(AuthContext);

  const onCallToActionClick = getOnCallToActionClick({
    canCreateSubmission: canCreate,
    canViewSubmission: canView,
    workflowStep,
    push: history.push,
    pathname,
    objectId,
    objectType,
    isManualMode,
    isPublic,
  });

  const ctaText = getCtaText(workflowStep);

  //we are hiding the button for public users when they can't take action on the step
  if (!onCallToActionClick && isPublic) {
    return null;
  }

  //whereas we show the disabled button to a view_only internal user if it's "create"
  return (
    <Button
      variant="outline"
      size="small"
      onPress={onCallToActionClick}
      isDisabled={!onCallToActionClick}
      data-testid="workflow-step-cta"
      title={ctaText}
    />
  );
};
